import React from "react"

import Popover from "../../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../core/gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../core/gd-components/gd-popover/@const"
import PopoverMenuHeader from "../../../../core/gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuOptionWithSubmenu
    from "../../../../core/gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOption from "../../../../core/gd-components/popover-menu/popover-menu/menu-option"
import PopoverMenuSeparator from "../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuOptionWithCustomPopover
    from "../../../../core/gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover"
import ArrayUtils from "../../../../core/gd/utils/array"
import ProjectSession from "../../../../core/model2/project/project-session"
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const"
import NavigationMenuAdd_PopoverNewView from "./add-view/add-view";
import menuAdd_productivityOptions from "./actions/productivity/productivity-options";
import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "./@types"
import {menuAdd_initEmbedLink} from "./actions/embed-link";
import navigationMenuAdd_initMore from "./actions/more";
import navigationMenuAdd_initFolder from "./actions/folder"
import navigationMenuAdd_initDocuments from "./actions/documents"

type Props = {
    className?          : string

    projectId?          : ID

    getTargetFunc       : func
    hidePopover         : func

    onAddInline         : {(inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams):void}

    showAdditionalViews?: boolean // Stupid name. Show or hide Dashboard and portfolio
}

// const debug = "NavigationMenuAddPopover"
const debug = false

export default function NavigationMenuAddPopover(props:Props) {

    // const [embedOptions, setEmbedOptions] = useState<any[] | null>(null)

    let popoversOpen: any[] = []

    const onAddInline = (inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams) => {
        props.onAddInline?.(inlineAddType, params)
        props.hidePopover()
    }

    const onClickOutside = (e?:React.SyntheticEvent) => {
        // if(gd.utils.Dom.findNodeByClassName(e.target, ["popover-submenu", "popover-option-custom",/* "views-dashboard"*/])) return
        // no event = gd.layout.popovers.closeAll(), which must close the menu even with a sub-popover open
        if (
            e
            && popoversOpen.length > 0
        ) {
            return
        }
        props.hidePopover()
    }

    const onTogglePopover = (value: boolean, option: any) => {
        if (value) {
            popoversOpen = ArrayUtils.addArrayObject(popoversOpen, option, (o:any)=>_.isEqual(o, option))
        } else {
            popoversOpen = ArrayUtils.removeArrayObject(popoversOpen, option, (o:any)=>_.isEqual(o, option))
        }
    }

    const project: ProjectSession | undefined = gd.session.projects.get(props.projectId) || undefined
    const canCreateProject:boolean      = project ? project.acl.canCreateProject   : true
    const disableNewFolder:boolean      = !canCreateProject
    const disableNewProject:boolean     = !canCreateProject
    const disableNewView:boolean        = !canCreateProject
    const disableNewDocument:boolean    = !canCreateProject

    debug && console.log(debug, 'process acl', disableNewFolder, project?.acl, project)

    let options: any[] = []

    // FOLDERS
    navigationMenuAdd_initFolder(options, {
        projectId   : props.projectId,
        project     : project,
        disabled    : disableNewFolder,
        hidePopover : props.hidePopover,
        onAddInline : onAddInline
    })

    // VIEW
    options.push({
        type                : PopoverMenuItemType.CUSTOM_POPOVER,
        icon                : 'i5-view',
        label               : 'View',
        disabled            : disableNewView, //!project,
        menuComponent       : NavigationMenuAdd_PopoverNewView,
        popoverClass        : 'ui-menu-add-view-popover',
        menuParams          : {
            projectId           : props.projectId,
            showAdditionalViews : props.showAdditionalViews
        }
    })

    // PRODUCTIVITY
    options.push({
        type        : PopoverMenuItemType.SUBMENU,
        icon        : 'ii5-flask-potion', // i5-idea
        label       : 'Productivity',
        disabled    : disableNewProject,
        options     : menuAdd_productivityOptions(onAddInline)
    })

    // EMBED LINK
    menuAdd_initEmbedLink(options, onAddInline, project)

    navigationMenuAdd_initMore(options, disableNewFolder, project || undefined)

    options.push({type: PopoverMenuItemType.SEPARATOR})

    // add work item - old
    // // show Work item options only for project
    // if (project) {
    //     const showWorkItemsOption   = project.acl.canCreateTask || project.acl.canCreateEvent || project.acl.canCreateDocument
    //
    //     if (showWorkItemsOption) {
    //         options.push({
    //             type    : PopoverMenuItemType.SUBMENU,
    //             icon    : 'i5-tasks',
    //             label   : 'Work item',
    //             options : [
    //                 // {type: 'header',        label: 'Add Work item'},
    //                 {icon: 'i5-task',       label: 'Task',      disabled: !project.acl.canCreateTask,      onClick: onAddTask},
    //                 {icon: 'i5-calendar',   label: 'Event',     disabled: !project.acl.canCreateEvent,     onClick: onAddEvent},
    //                 {icon: 'i5-document',   label: 'Document',  disabled: !project.acl.canCreateDocument,  onClick: onAddDocument},
    //             ]
    //         })
    //
    //         options.push({type: PopoverMenuItemType.SEPARATOR})
    //     }
    // }


    // DOCUMENT
    navigationMenuAdd_initDocuments(options, {
        projectId           : props.projectId,
        disableNewDocument  : disableNewDocument,
        disableNewView      : disableNewView,
        hidePopover         : props.hidePopover,
        onAddInline         : onAddInline
    })

    const popoverPosition = new PopoverPosition({
        offset          : "0 0",
        attachment      : "top left",
        targetAttachment: "top right",
        attachmentType  : PopoverAttachmentType.VERTICAL,
    })

    return (
        <Popover popoverClass             = "ui-menu-more-popover"
                 autoVisibleTarget          = {true}
                 position                   = {popoverPosition}
                 constraints                = {[{
                     to         : 'window',
                     attachment : 'together',
                     pin        : true
                 }]}
                 getTargetFunc              = {props.getTargetFunc}
                 onClickOutside             = {onClickOutside}>

            <div className="ui5-popover-menu min-w-250i">
                {_.map(options, (option:any, key:number)=> {

                    switch (option.type) {

                        case PopoverMenuItemType.SEPARATOR:
                            return <PopoverMenuSeparator key={key}/>
                        case PopoverMenuItemType.HEADER:
                            return <PopoverMenuHeader key={key} title={option.label}/>
                        case PopoverMenuItemType.SUBMENU:
                            return <PopoverMenuOptionWithSubmenu key                = {'popover_{0}'.f(key)}
                                                                 option             = {option}
                                                                 onTogglePopover    = {(value: boolean)=>{onTogglePopover(value, option)}}/>
                        case PopoverMenuItemType.CUSTOM_POPOVER:
                            return <PopoverMenuOptionWithCustomPopover key              = {'popover_{0}'.f(key)}
                                                                       option           = {option}
                                                                       disabled         = {option.disabled}
                                                                       menuParams       = {option.menuParams}
                                                                       onTogglePopover  = {(value: boolean)=>{onTogglePopover(value, option)}}/>

                        case PopoverMenuItemType.MODAL:
                            return <PopoverMenuOption key       = {key}
                                                      showArrow = {true}
                                                      option    = {option}/>

                        case PopoverMenuItemType.ITEM:
                        default:
                            return <PopoverMenuOption key       = {key}
                                                      option    = {option}/>
                    }

                })}
            </div>
        </Popover>
    )
}
